export default __webpack_public_path__ + "static/media/bulb.c6849e60.svg";